import { s } from "@kosmod/pancake";
import { defineTool } from "./define";

export const dev = {
  vis: defineTool({
    key: 'dev:vis',
    state: s.o({
      canvas: s.lu([
        'none',
        'interior',
        'neighbors',
        'visibility',
        'walkable'
      ])
    })
  }),
}